"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const react_1 = __importStar(require("react"));
const Form_1 = __importDefault(require("../Form"));
const placeholders_1 = require("../placeholders");
const common_1 = require("./common");
// these values are used for change detection
const defaultProps = { defaultValue: {}, formKey: 'staticKey' };
const InputModal = ({ open, onClose, onCreate = () => null, onChange = () => null, title, fields, defaultValue = defaultProps.defaultValue, formKey = defaultProps.formKey, children, invalidFields = {}, saveLabel = 'Create', renderActions = null, bottomContent, }) => {
    const actualRenderActions = react_1.useCallback((formId) => {
        if (renderActions)
            return renderActions(formId);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Button_1.default, { onClick: onClose }, "Cancel"),
            react_1.default.createElement(placeholders_1.FlexExpander, null),
            react_1.default.createElement(Button_1.default, { color: "primary", type: "submit", form: formId }, saveLabel)));
    }, [onClose, saveLabel, renderActions]);
    return (react_1.default.createElement(Dialog_1.default, { "aria-labelledby": "input-dialog-title", TransitionComponent: common_1.SlideUp, open: open, onClose: onClose, fullWidth: true, maxWidth: "sm" },
        react_1.default.createElement(DialogTitle_1.default, { id: "input-dialog-title" }, title),
        react_1.default.createElement(Form_1.default, { key: formKey, fields: fields, defaultValue: defaultValue, ContentWrapper: DialogContent_1.default, ActionsWrapper: DialogActions_1.default, renderActions: actualRenderActions, onSubmit: onCreate, onChange: onChange, invalidFields: invalidFields, bottomContent: bottomContent, InputModal: InputModal }, children)));
};
exports.default = InputModal;
//# sourceMappingURL=InputModal.js.map